module.exports = __webpack_public_path__ + "img/20.10.pH.c5fbb95d.png";